/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";

const PushNotificationsTable = ({ pushNotifications, companyURL, onClickDelete }) => {
  const TableOrNotFound = () => {
    if (pushNotifications.loading) {
      return "is Loading";
    }
    if (isEmpty(pushNotifications.data)) {
      return (
        <p className="is-size-2 has-text-centered has-text-grey">
          Found Nothing
        </p>
      );
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Price</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {pushNotifications.data.map(pushNotification => (
            <tr key={pushNotification.id}>
              <td>{pushNotification.id}</td>
              <td>{pushNotification.name}</td>
              <td>{pushNotification.price}</td>

              <td className="is-icon">
                <p className="buttons">
                  <Link
                    to={`/${companyURL}/pushNotifications/${pushNotification.id}/edit`}
                    className="button  is-link is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Edit</span>
                  </Link>
                  <a
                    onClick={onClickDelete(pushNotification.id)}
                    to={`/${companyURL}/pushNotifications/${pushNotification.id}/delete`}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};
export default PushNotificationsTable;
